import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Spinner,
  ModalBody,
  Text,
} from '@chakra-ui/react';

const ModalSpinner = ({ isOpen, progress }) => {
  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent color='white' backgroundColor='#3c4d5f'>
        <ModalHeader>Attendere prego...</ModalHeader>
        <ModalBody py={10} textAlign={'center'}>
          <Spinner
            thickness='4px'
            speed='0.65s'
            emptyColor='gray.200'
            color='teal.500'
            size='xl'
          />
          {progress && (
            <Text my={5} fontSize='3xl'>
              {progress}%
            </Text>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ModalSpinner